<template>
  <div class='sheader'>
    <h2 class='heading-tertiary'>{{$t(title)}}</h2>
    <ToolBar></ToolBar>
  </div>
</template>

<script>
import ToolBar from '../components/Toolbar.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('subheader')

export default {
  data: function () {
    return {
    }
  },
  components: {
    ToolBar
  },
  computed: {
    ...mapGetters({
      title: 'getTitle'
    })
  }
}
</script>
